import { analytics } from './firebase'

export function setUser(user) {
  const userId = user ? user.uid : undefined
  analytics.setUserId(userId)
}

export function setUserClaims({
  accountId,
  accountType,
  isSignatory,
  isAccountAdmin,
  jobTitle,
  industry
}) {
  analytics.setUserProperties({
    accountId,
    accountType,
    isSignatory,
    isAccountAdmin,
    ...(jobTitle && { jobTitle }),
    ...(industry && { industry })
  })
}

function urlForPath(path) {
  if (path.startsWith('http:')) {
    return path
  }
  return `${window.location.origin}${path}`
}

export function logPageView({ title, path, referrer, meta = {} }) {
  logEvent('page_view', {
    page_title: title,
    page_location: urlForPath(path),
    page_path: path,
    page_referrer: referrer ? urlForPath(referrer) : undefined,
    ...meta
  })
}

export function logMfaEnabled() {
  logEvent('mfa_enabled')
}

function logEvent(eventName, params = {}) {
  analytics.logEvent(eventName, params)
}
